const STORAGE_KEY = "product_form_field_subfields";


const PRICE_TIER_SUB_FIELDS = [
  { name: "band_1", label: "Price 1" },
  { name: "band_2", label: "Price 2" },
  { name: "band_3", label: "Price 3" },
  { name: "band_4", label: "Price 4" },
  { name: "band_5", label: "Price 5" },
  { name: "band_6", label: "Price 6" },
];

export const PRODUCT_FIELD_SUBFIELDS = {
  price_box: PRICE_TIER_SUB_FIELDS,
  special_price_box: PRICE_TIER_SUB_FIELDS,
  price_piece: PRICE_TIER_SUB_FIELDS,
  special_price_piece: PRICE_TIER_SUB_FIELDS,
  box_prices: PRICE_TIER_SUB_FIELDS,
  box_pricing: PRICE_TIER_SUB_FIELDS,
  box_price_bands: PRICE_TIER_SUB_FIELDS,
  piece_prices: PRICE_TIER_SUB_FIELDS,
  piece_pricing: PRICE_TIER_SUB_FIELDS,
  piece_price_bands: PRICE_TIER_SUB_FIELDS,
  both: PRICE_TIER_SUB_FIELDS,
  both_prices: PRICE_TIER_SUB_FIELDS,
  both_pricing: PRICE_TIER_SUB_FIELDS,
};

const FIELD_STORAGE_ALIASES = {
  price_box: ["price_box", "box_prices", "box_pricing", "box_price_bands"],
  special_price_box: ["special_price_box", "box_prices", "box_pricing", "box_price_bands"],
  price_piece: ["price_piece", "piece_prices", "piece_pricing", "piece_price_bands"],
  special_price_piece: [
    "special_price_piece",
    "piece_prices",
    "piece_pricing",
    "piece_price_bands",
  ],
  both: ["both", "both_prices", "both_pricing"],
  both_prices: ["both", "both_prices", "both_pricing"],
  both_pricing: ["both", "both_prices", "both_pricing"],
  box_prices: ["box_prices", "box_pricing", "box_price_bands", "price_box"],
  box_pricing: ["box_prices", "box_pricing", "box_price_bands", "price_box"],
  box_price_bands: ["box_prices", "box_pricing", "box_price_bands", "price_box"],
  piece_prices: ["piece_prices", "piece_pricing", "piece_price_bands", "price_piece"],
  piece_pricing: ["piece_prices", "piece_pricing", "piece_price_bands", "price_piece"],
  piece_price_bands: ["piece_prices", "piece_pricing", "piece_price_bands", "price_piece"],
};

const isVisibleFlag = (value) =>
  value !== false && value !== 0 && value !== "0";

export const normalizeSubFieldName = (name = "") => {
  const raw = String(name || "").trim().toLowerCase();
  if (!raw) return "";
  if (raw === "0" || raw === "box") return "box";
  if (raw === "1" || raw === "piece") return "piece";
  if (raw === "2" || raw === "both") return "both";
  if (/^(band|price)[_\s-]?([1-6])$/.test(raw)) {
    return `band_${raw.replace(/\D/g, "")}`;
  }
  if (
    raw === "box_cost" ||
    raw === "cost" ||
    raw === "box cost"
  ) {
    return "box_cost";
  }
  if (
    raw === "recommended_selling_price" ||
    raw === "recommendedsellingboxprice" ||
    raw === "recommended_selling_box_price"
  ) {
    return "recommended_selling_price";
  }
  if (
    raw === "box_margin" ||
    raw === "margin" ||
    raw === "box_margin(%)" ||
    raw === "box margin(%)"
  ) {
    return "box_margin";
  }
  if (raw === "piece_cost" || raw === "piece cost") {
    return "piece_cost";
  }
  if (
    raw === "piece_recommended_selling_price" ||
    raw === "recommendedsellingpieceprice" ||
    raw === "recommended_selling_piece_price"
  ) {
    return "piece_recommended_selling_price";
  }
  if (
    raw === "piece_margin" ||
    raw === "piece_margin(%)" ||
    raw === "piece margin(%)"
  ) {
    return "piece_margin";
  }
  if (raw === "price_(box)" || raw === "price box" || raw === "box_price") {
    return "price_box";
  }
  if (
    raw === "special_price_(box)" ||
    raw === "special price (box)" ||
    raw === "special_box_price"
  ) {
    return "special_price_box";
  }
  if (raw === "price_(piece)" || raw === "price piece" || raw === "piece_price") {
    return "price_piece";
  }
  if (
    raw === "special_price_(piece)" ||
    raw === "special price (piece)" ||
    raw === "special_piece_price"
  ) {
    return "special_price_piece";
  }
  return raw.replace(/\s+/g, "_");
};

export const getDefaultSubFieldsFor = (fieldName = "") => {
  const key = String(fieldName || "").trim();
  if (PRODUCT_FIELD_SUBFIELDS[key]) return PRODUCT_FIELD_SUBFIELDS[key];
  return [];
};

const readLocalStore = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const readLocalSubFields = (fieldName) => {
  const store = readLocalStore();
  const value = store[fieldName];
  return value && typeof value === "object" ? value : null;
};

export const saveLocalSubFieldsMap = (fieldsMap = {}) => {
  try {
    const store = readLocalStore();
    Object.entries(fieldsMap).forEach(([fieldName, subMap]) => {
      if (!fieldName || !subMap || typeof subMap !== "object") return;
      store[fieldName] = subMap;
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
  }
};

const resolveSavedSubFields = (fieldName) => {
  const aliases = FIELD_STORAGE_ALIASES[fieldName] || [fieldName];
  for (let i = 0; i < aliases.length; i += 1) {
    const saved = readLocalSubFields(aliases[i]);
    if (saved) return saved;
  }
  return null;
};

export const buildSubFieldRows = (fieldName, nestedFields = []) => {
  const defaults = getDefaultSubFieldsFor(fieldName);
  const byName = new Map();
  const knownKeys = new Set(defaults.map((item) => item.name));
  const hasApiNested = (nestedFields || []).some(
    (field) => field?.name || field?.field_name || field?.key,
  );

  defaults.forEach((item) => {
    byName.set(item.name, {
      name: item.name,
      label: item.label,
      visible: !hasApiNested,
    });
  });

  (nestedFields || []).forEach((field) => {
    const name = normalizeSubFieldName(field?.name || field?.field_name || field?.key);
    if (!name) return;
    if (knownKeys.size && !knownKeys.has(name)) return;
    const existing = byName.get(name);
    byName.set(name, {
      name,
      label: existing?.label || field.label || field.field_label || name,
      visible: isVisibleFlag(field.visible),
    });
  });

  const fieldSaved = hasApiNested ? null : resolveSavedSubFields(fieldName);
  if (fieldSaved) {
    Object.entries(fieldSaved).forEach(([name, visible]) => {
      const key = normalizeSubFieldName(name);
      if (!key) return;
      if (knownKeys.size && !knownKeys.has(key)) return;
      const existing = byName.get(key);
      byName.set(key, {
        name: key,
        label: existing?.label || key,
        visible: !!visible,
      });
    });
  }

  return [...byName.values()];
};

export const resolveVisibleSubFieldMap = ({
  fieldName = "",
  nestedFields = [],
} = {}) => {
  const rows = buildSubFieldRows(fieldName, nestedFields);
  const map = {};
  rows.forEach((row) => {
    map[row.name] = row.visible !== false;
  });
  return map;
};

export const mergePriceTierVisibleMap = (...maps) => {
  const present = maps.filter((map) => map && typeof map === "object");
  const hasAny = present.some((map) => Object.keys(map).length);
  const merged = {};
  for (let i = 1; i <= 6; i += 1) {
    const key = `band_${i}`;
    const defined = present.filter((map) =>
      Object.prototype.hasOwnProperty.call(map, key),
    );
    if (!defined.length) {
      merged[key] = !hasAny;
      continue;
    }
    merged[key] = defined.some((map) => !!map[key]);
  }
  return merged;
};

export const isSubFieldVisible = (visibleSubFields, key) => {
  if (visibleSubFields == null) return true;
  if (typeof visibleSubFields !== "object") return true;
  if (!(key in visibleSubFields)) return false;
  return !!visibleSubFields[key];
};

export const resolvePriceTierMapFromField = (field, fieldName = "") => {
  if (!field || field.visible === false) return {};
  return resolveVisibleSubFieldMap({
    fieldName,
    nestedFields: field.fields || field.sub_fields || [],
  });
};
